import Api, { Fare, Porter } from '@silbo/core';

export const getFaresQuery = (porter?: Porter) =>
  new Api.Query(Fare)
    .include('patient', 'fromUnit', 'toUnit', 'fromArea.parent', 'toArea.parent', 'incidents', 'assignations')
    .equalTo('porters', porter)
    .exists('porters')
    .ascending('wantedDate')
    .notEqualTo('status', 'DONE');
